import React from "react";
import WalkInDetails from "./walkInDetails";

class WalkInDetailsParent extends React.Component {
  render() {
    return <WalkInDetails />;
  }
}

export default WalkInDetailsParent;